import { IssueTracker } from '../../../cimsPage/instances/issues'
import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
} from '../../common'

const page = IssueTracker
const object = 'Issue'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: 'D7688C82-8DE5-4C63-9339-4B74DBD84396',
  edit: '897F20E9-21F5-4C8C-B0C9-F723D9050B22',
  removeRestore: 'B95E16E3-F6E2-409A-A74A-623ABE6CF32E',
  view: '1D82DF89-0454-46AA-93AC-71D66F8661B0',
})

export const CreateIssue = Create
export const EditIssue = Edit
export const RemoveRestoreIssue = RemoveRestore
export const ViewIssue = View

export const EditIssueResponse = new BasicPermissionItem({
  id: 'CE547FA9-B01D-43AB-B951-5601650FCC7B',
  page,
  action: 'Edit Response',
  name: 'Edit Issue Response',
})

export const CommentOnIssue = Simple({
  id: '93474E4D-6AEB-4AE0-B9D0-C14FC41EBEB7',
  action: 'Comment on',
  object,
  page,
})

export const RevertIssue = Revert({
  id: '6FFE8123-9ACC-48C1-B918-DD6243737D7F',
  object,
  page,
})

export const UnlockIssue = Unlock({
  id: 'E8FE7AAB-3962-40F2-BD36-AF6CF5D8C93E',
  page,
  object,
})

export const RespondToIssue = new BasicPermissionItem({
  id: '24F1B3A8-27BE-41A4-842B-6683BBC6BC93',
  name: 'Respond',
  action: `respond to an ${object}`,
  allowMixedCase: true,
  page,
})

export const GiveIssueDisposition = GiveDisposition({
  id: 'A5EC93BD-6A73-4ABD-AAE6-1C74DEEFD10F',
  object,
  page,
})

export const CloseIssue = Simple({
  id: '27E11CA1-817F-440F-95D0-7526539D2C63',
  action: 'Close',
  object,
  page,
})

export type IssueTrackerPermission =
  | typeof CreateIssue
  | typeof EditIssue
  | typeof RemoveRestoreIssue
  | typeof ViewIssue
  | typeof EditIssueResponse
  | typeof CommentOnIssue
  | typeof RevertIssue
  | typeof UnlockIssue
  | typeof RespondToIssue
  | typeof GiveIssueDisposition
  | typeof CloseIssue
